// This file can be replaced during build by using the `fileReplacements` array.	
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.	
// The list of file replacements can be found in `angular.json`.	

export const environment = {
    production: false,
    //api: 'http://localhost:8080/api/',
    //api: 'https://isoforms.velocity-np.ag/api/',
    api: 'http://ec2-3-225-113-162.compute-1.amazonaws.com:8080/api/',
    api_adm: 'http://ec2-3-225-113-162.compute-1.amazonaws.com:8080/adm/api/',
    refreshToken: false
};